export enum Language {
	sk = 'sk',
	en = 'en',
	cs = 'cs',
	pl = 'pl',
	de = 'de',
	it = 'it',
	hu = 'hu',
}
